const capitalizeCharacter = (string = "") => {
	const s = string?.toLowerCase();

	if(s) return s.split(" ").map((o) => o.charAt(0).toUpperCase() + o.slice(1)).join(" ");
	
	return "";
};

export default capitalizeCharacter;
